import { deserializeSuperjson, serializeSuperjson } from '@lib/superjson';
import type {
  UpdateSnapSiteConfigRequest,
  UpdateSnapSiteConfigResponse,
} from '@snap-types/actions/update-snap-site-config';
import { injectEndpoints } from '@ui/store/api-builder/inject-mutation';

const injectedApi = injectEndpoints({
  endpoints: (builder) => ({
    updateSnapSiteConfig: builder.mutation<
      UpdateSnapSiteConfigResponse,
      UpdateSnapSiteConfigRequest
    >({
      transformResponse: deserializeSuperjson,
      query: ({ params, body }) => ({
        url: `/admin/sites/${params.siteCode.toLowerCase()}/snap-site-config/${params.snapSiteConfigUuid}`,
        method: 'PUT',
        body: serializeSuperjson(body),
      }),
      invalidatesTags: (_result, _error, args) => [
        { type: 'EditSnapQuoteBySiteCode', id: args.params.siteCode },
        { type: 'EditSnapSiteConfig', id: args.params.snapSiteConfigUuid },
      ],
    }),
  }),
});

export const updateSnapSiteConfig = injectedApi.endpoints.updateSnapSiteConfig;
export const useUpdateSnapSiteConfigMutation = updateSnapSiteConfig.useMutation;
